"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsidePortal = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const react_use_1 = require("react-use");
const react_resizable_1 = require("react-resizable");
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const styled_1 = require("./styled");
const voidFunc = () => {
    return;
};
const DEFAULT_WIDTH = 360;
const AsidePortal = (_a) => {
    var { children, isOpen = false, handleResizeSide, shadeBackground = false, style = {}, position, onClose, onClickOutside, id = 'aside-portal', title, key, Wrapper = styled_1.AsidePortalWrapper, Header = wl_ui_kit_1.CardHeader, Content = styled_1.AsidePortalContent, Footer, onResize } = _a, props = __rest(_a, ["children", "isOpen", "handleResizeSide", "shadeBackground", "style", "position", "onClose", "onClickOutside", "id", "title", "key", "Wrapper", "Header", "Content", "Footer", "onResize"]);
    const asidePortalWrapperRef = (0, react_1.useRef)(null);
    const [node, setNode] = (0, react_1.useState)(null);
    const initialWidth = (0, react_1.useMemo)(() => { var _a, _b; return Number.parseInt((_b = (_a = style === null || style === void 0 ? void 0 : style.width) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : ''); }, []);
    const [width, setWidth] = (0, react_1.useState)(Number.isNaN(initialWidth) ? DEFAULT_WIDTH : initialWidth);
    const handleSetWidth = (e, data) => {
        if (onResize) {
            onResize(e, data);
        }
        setWidth(data.size.width);
    };
    (0, react_use_1.useClickAway)(asidePortalWrapperRef, onClickOutside !== null && onClickOutside !== void 0 ? onClickOutside : voidFunc);
    const resizeHandles = (0, react_1.useMemo)(() => {
        if (handleResizeSide === 'left')
            return ['w'];
        if (handleResizeSide === 'right')
            return ['e'];
        return [];
    }, [handleResizeSide]);
    (0, react_1.useEffect)(() => {
        const eliminateNode = (node) => {
            setNode(null);
            react_dom_1.default.unmountComponentAtNode(node);
            node.remove();
        };
        const createNode = (id) => {
            const portalNode = document.createElement('aside');
            portalNode.id = id;
            portalNode.hidden = !isOpen;
            document.body.appendChild(portalNode);
            return portalNode;
        };
        const prevNode = document.getElementById(id);
        if (prevNode)
            eliminateNode(prevNode);
        const newNode = createNode(id);
        setNode(newNode);
        return () => {
            newNode && eliminateNode(newNode);
        };
    }, [id, isOpen]);
    return !isOpen || !node
        ? null
        : react_dom_1.default.createPortal(react_1.default.createElement(react_1.default.Fragment, null,
            shadeBackground ? react_1.default.createElement(styled_1.Shading, { "data-testid": "aside-portal-shading" }) : null,
            react_1.default.createElement(react_resizable_1.Resizable, { axis: "x", width: width, onResize: handleSetWidth, resizeHandles: resizeHandles },
                react_1.default.createElement(Wrapper, Object.assign({ style: Object.assign(Object.assign({}, style), { width }), 
                    /* @ts-ignore */
                    ref: asidePortalWrapperRef, "$position": position, action: onClose ? (react_1.default.createElement(wl_ui_kit_1.IconButton, { "data-testid": "btn-close-portal", onClick: onClose },
                        react_1.default.createElement(wl_ui_kit_1.Icon, { name: "close" }))) : undefined }, props),
                    title && react_1.default.createElement(Header, { component: "h4" }, title),
                    react_1.default.createElement(Content, null, children),
                    Footer && react_1.default.createElement(styled_1.FooterWrapper, null, Footer)))), node, key);
};
exports.AsidePortal = AsidePortal;
